<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup" :title="'CADASTRO DE USUÁRIO'" :showClearButton="true" :showSaveButton="true"
      :showBackButton="true" v-on:Clear="onClear" v-on:Back="onBack" v-on:Save="onSave">

      <div class="form-group row">
        <b-form-group :label="$lang.Accounts.LabelUserExternal" class="col-md-6">
          <b-form-radio-group id="external-user" v-model="formAccount.externalUser.value"
            :options="formAccount.externalUser.options" :required="formAccount.externalUser.required"
            :state="formAccount.externalUser.state" @change="onChangeExternalUser" name="isExternalUser"
            stacked></b-form-radio-group>
        </b-form-group>
      </div>

      <div class="form-group row" v-if="formAccount.externalUser.value && !editMode">
        <div class="col-md-2">
          <label for="txtName"><small v-show="formPerson.tipoPessoa.required" class="text-danger">*</small> Tipo
            Pessoa:</label>
          <div class="input-group">
            <b-form-select v-model="formPerson.tipoPessoa.value" :options="formPerson.tipoPessoa.options">
              <template slot="first">
                <option :value="''">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-show="formPerson.document.required" class="text-danger">*</small> Numero do
            documento:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o numero do documento'" v-model="formPerson.document.value"
              v-mask="['###.###.###-##', '##.###.###/####-##']" :required="formPerson.document.required"
              :state="formPerson.document.state" @change="validateDocument(formPerson.document)"></b-form-input>
          </div>
        </div>
        <div class="col-md-7">
          <label for="txtName"><small v-show="formPerson.emailCorporativo.required" class="text-danger">*</small> E-mail Corporativo:</label>
          <div class="input-group">
            <b-form-input type="email" :placeholder="'Digite o E-mail'" v-model="formPerson.emailCorporativo.value"
              :size="formPerson.emailCorporativo.maxlength" :required="formPerson.emailCorporativo.required"
              :state="formPerson.emailCorporativo.state"></b-form-input>
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="!formAccount.externalUser.value">
        <div class="col-md-6">
          <label for="txtName"><small v-show="formAccount.funcionarioId.required" class="text-danger">*</small>
            {{ $lang.Accounts.LabelEmployee }}:</label>
          <div class="input-group">
            <v-select v-if="!editMode || !hasFuncionarioId" v-model="formAccount.funcionarioId.value"
              :options="formAccount.funcionarioId.options" :reduce="(opt) => opt.value" label="text" class="w-100"
              :disabled="!hasFuncionarioId ? false : editMode">
              <template v-slot:no-options>Nenhum funcionário encontrado.</template>
            </v-select>

            <b-form-input v-else type="text" :placeholder="$lang.Accounts.PlaceholderEnterLogin"
              v-model="formAccount.nomePessoa.value" :size="formAccount.nomePessoa.maxlength"
              :required="formAccount.nomePessoa.required" :state="formAccount.nomePessoa.state"
              :disabled="editMode"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label><small v-show="formAccount.mfaActive.required" class="text-danger">*</small> Duplo Fator de
            Autenticação:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-shield-alt"></i></span>
            <b-form-select v-model="formAccount.mfaActive.value" :options="formAccount.mfaActive.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                <option :value="true">SIM</option>
                <option :value="false">NÃO</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>

      <div class="form-group row pt-2">
        <div class="col-md-6" v-if="formAccount.externalUser.value && !editMode">
          <label for="txtName"><small v-show="formPerson.nome.required" class="text-danger">*</small> Nome
            Completo:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o Nome Completo'" v-model="formPerson.nome.value"
              :size="formPerson.nome.maxlength" :required="formPerson.nome.required"
              :state="formPerson.nome.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-6" :class="formAccount.externalUser.value && 'mb-2'">
          <label for="txtName"><small v-show="formAccount.username.required" class="text-danger">*</small>
            {{ $lang.Accounts.LabelLogin }}:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="$lang.Accounts.PlaceholderEnterLogin"
              v-model="formAccount.username.value" :size="formAccount.username.maxlength"
              :required="formAccount.username.required" :state="formAccount.username.state"></b-form-input>
          </div>
        </div>
        <div v-if="formAccount.externalUser.value && editMode" class="col-md-6">
          <label for="txtName"><small v-show="formPerson.emailCorporativo.required" class="text-danger">*</small> E-mail Corporativo:</label>
          <div class="input-group">
            <b-form-input type="email" :placeholder="'Digite o E-mail'" v-model="formPerson.emailCorporativo.value"
              :size="formPerson.emailCorporativo.maxlength" :required="formPerson.emailCorporativo.required"
              :state="formPerson.emailCorporativo.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-6" v-if="!formAccount.externalUser.value">
          <label for="txtEmail"><small v-show="formAccount.administrador.required" class="text-danger">*</small>
            {{ $lang.Accounts.LabelAdministrator }}:</label>
          <div class="input-group">
            <b-form-select v-model="formAccount.administrador.value" :options="formAccount.administrador.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                <option :value="true">SIM</option>
                <option :value="false">NÃO</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>

      <div v-if="!formAccount.externalUser.value" class="form-group row pt-2 mb-3">
        <div class="col-md-6">
          <label for="permissionSelect"> Permissões:</label>
          <v-select multiple v-model="formAccount.permissoes.value" :options="formAccount.permissoes.options"
            :reduce="option => option.value" class="w-100" label="name">
            <template v-slot:no-options>Nenhum Funcionário encontrado.</template>
          </v-select>
        </div>
        <div class="col-md-6">
          <label for="permissionSelect"> Acessos:</label>
          <v-select multiple v-model="formAccount.acessos.value" :options="formAccount.acessos.options"
            :reduce="option => option.value" class="w-100" label="name">
            <template v-slot:no-options>Nenhum Funcionário encontrado.</template>
          </v-select>
        </div>
      </div>

      <div class="form-group row pt-2 mb-3">
        <div class="col-md-6">
          <label for="permissionSelect"> {{ $lang.Accounts.LabelGroup }}</label>
          <v-select multiple v-model="formAccount.grupos.value" :options="formAccount.grupos.options"
            :getOptionLabel="(opt) => opt.text" class="w-100" label="name">
            <template v-slot:no-options>{{ $lang.Accounts.NoGroupFound }}</template>
          </v-select>
        </div>

        <div class="col-md-6" v-if="!formAccount.externalUser.value">
          <label for="permissionSelect"> Gerente Substituto</label>
          <v-select
            v-model="formAccount.funcionarioSubstitutoId.value"
            :options="formAccount.funcionarioSubstitutoId.options"
            :reduce="(opt) => opt.value"
            label="text"
            class="w-100"
          >
            <template v-slot:no-options>Nenhum funcionário encontrado.</template>
          </v-select>
        </div>
      </div>

      <PermissionsTable v-if="!formAccount.externalUser.value" ref="PermissionsTable" :idFuncionarios="idFuncionarios"
        @UpdatePermissionList="updatePermissionList"></PermissionsTable>

      <div class="form-group row">
        <div class="col-md-12 pt-1">
          <h5 class="text-third"><i class="fa fa-lock"></i> {{ $lang.Accounts.AccessPasswords }}</h5>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtPassword">{{ $lang.Accounts.LabelPassword }}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <b-form-input type="password" :placeholder="$lang.Accounts.PlaceholderEnterPassword"
              v-model="formAccount.password.value" :size="formAccount.password.maxlength"
              :required="formAccount.password.required" :state="formAccount.password.state" autocomplete="new-password"
              @input="validatePassword(formAccount.password.value)"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtConfirmation">{{ $lang.Accounts.LabelConfirmation }}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <b-form-input type="password" :placeholder="$lang.Accounts.PlaceholderConfirmationPassword"
              v-model="formAccount.confirmation.value" :size="formAccount.confirmation.maxlength"
              :required="formAccount.confirmation.required" :state="formAccount.confirmation.state"
              autocomplete="new-password" @blur.native="onCheckPassword"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <small class="text-third"><i class="fa fa-info-circle"></i>
            {{ $lang.Accounts.PasswordOnlyNewRegistration }}</small>
        </div>
      </div>
      <hr>
      <span style="font-weight: 700">Requisitos Mínimos:</span>
      <ul>
        <li :class="lengthValid ? 'text-success' : 'text-danger'">
          Comprimento mínimo de 8 caracteres
        </li>
        <li :class="uppercaseValid ? 'text-success' : 'text-danger'">
          Letra maiúscula
        </li>
        <li :class="lowercaseValid ? 'text-success' : 'text-danger'">
          Letra minúscula
        </li>
        <li :class="numberValid ? 'text-success' : 'text-danger'">
          Número (1 - 9)
        </li>
        <li :class="specialCharValid ? 'text-success' : 'text-danger'">
          Caractere especial (!@#$%&*()+-)
        </li>
      </ul>
    </Forms>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import PersonModel from '@/shared/models/configurations/personmodel.js'
import PersonForms from './person-form.js'
import AccountModel from '@/shared/models/configurations/accountmodel.js'
import AccountForms from './account-form.js'

import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'
import GroupRepository from '@/shared/http/repositories/configurations/group.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'

import PermissionsTable from '../permissionEmployees/permissionsTable.vue'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'AccountAdd',
  mixins: [ActionsForm],
  components: {
    PermissionsTable
  },
  data () {
    return {
      editMode: false,
      dataAccount: AccountModel,
      formAccount: AccountForms,
      dataPerson: PersonModel,
      formPerson: PersonForms,
      usersList: [],
      usersAlreadyWithPermission: [],
      idFuncionarios: new Set(),
      hasFuncionarioId: false,
      lengthValid: false,
      uppercaseValid: false,
      lowercaseValid: false,
      numberValid: false,
      specialCharValid: false,
      validPassword: false
    }
  },
  created () {
    this.loadEmployees()
    this.loadGroups()
    this.formAccount.username.disabled = false
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onClear () {
      delete this.formAccount['id']
      delete this.formPerson['id']
      Tools.ClearDataForms(this.formAccount, this.dataAccount)
      Tools.ClearDataForms(this.formPerson, this.dataPerson)
      if (this.alert) {
        this.alert.Close()
      }
    },
    onEdit (obj) {
      loading.push()
      this.editMode = true
      Tools.SetValueInForm(this.formAccount, this.dataAccount, obj)
      Tools.SetValueInForm(this.formPerson, this.dataPerson, obj.pessoa)
      this.verifyHasFuncionarioId(obj)
      if (obj.funcionario) {
        this.formAccount.funcionarioId.value = obj.funcionario.id
      }
      if (obj.funcionarioSubstituto) {
        this.formAccount.funcionarioSubstitutoId.value = obj.funcionarioSubstituto.id
      }
      if (obj.pessoa) {
        this.formAccount.nomePessoa.value = obj.pessoa.nome
        this.formAccount.nomePessoa.value = this.formAccount.nomePessoa.value.replace(/^\s+/g, '')
        this.formAccount.pessoaId.value = obj.pessoa.id
      }
      obj.funcionariosPermissao.forEach(x => {
        this.idFuncionarios.add(x.id)
      })
      if (obj.grupos) {
        this.formAccount.grupos.value = []
        obj.grupos.forEach(x => {
          this.formAccount.grupos.value.push({ 'text': x.nameGroup, 'value': x.id })
        })
      }

      this.onChangeExternalUser()

      if (this.idFuncionarios.size !== 0) {
        this.$refs.PermissionsTable.setEmployeesAlreadyWithPermission(this.idFuncionarios)
      }
      loading.pop()
    },
    validatePassword (password) {
      this.lengthValid = password.length >= 8
      this.uppercaseValid = /[A-Z]/.test(password)
      this.lowercaseValid = /[a-z]/.test(password)
      this.numberValid = /\d/.test(password)
      this.specialCharValid = /[!@#$%&*()+-]/.test(password)
    },
    onCheckPassword () {
      const password = this.formAccount.password.value
      const confirmation = this.formAccount.confirmation.value

      if (!password) {
        return
      }

      const minLength = 8
      const hasUppercase = /[A-Z]/.test(password)
      const hasLowercase = /[a-z]/.test(password)
      const numberValid = /\d/.test(password)
      const specialCharValid = /[!@#$%&*()+-]/.test(password)

      if (password.length < minLength) {
        toast.warning('ATENÇÃO! A senha deve conter no mínimo 8 caracteres')
        this.resetPasswordFields()
        return
      }

      if (!hasUppercase || !hasLowercase || !numberValid || !specialCharValid) {
        toast.warning(
          'ATENÇÃO! A senha precisa ter no mínimo um caractere:<br><ul><li>Letra Maiúscula</li><li>Letra Minúscula</li><li>Número (1 - 9)</li><li>Especial (!@#$)</li></ul>'
        )
        this.resetPasswordFields()
        return
      }

      if (confirmation && password !== confirmation) {
        toast.warning(
          'ATENÇÃO! A senha e sua confirmação não são iguais. Verifique e informe novamente, por favor'
        )
        this.resetPasswordFields()
        return
      }

      this.validPassword = true
    },
    resetPasswordFields () {
      this.formAccount.confirmation.value = ''
      this.formAccount.password.value = ''
      this.lengthValid = false
      this.uppercaseValid = false
      this.lowercaseValid = false
      this.numberValid = false
      this.specialCharValid = false
    },
    onSave () {
      if (this.editMode && this.formAccount.confirmation.value && this.formAccount.password.value && !this.validPassword) {
        this.validPassword = true
        return
      }

      if (Tools.ValidateForms(this.formAccount, this.dataAccount, this, toast) && Tools.ValidateForms(this.formPerson, this.dataPerson, this, toast)) {
        if (this.dataAccount.id !== null && this.dataAccount.id !== '00000000-0000-0000-0000-000000000000') {
          this.dataAccount.status = parseInt(this.dataAccount.status)
          this.onUpdate()
        } else {
          this.formAccount.id = null // '00000000-0000-0000-0000-000000000000'
          this.dataPerson.id = null // '00000000-0000-0000-0000-000000000000'
          this.formAccount.status = 1
          this.dataPerson.status = 1
          this.onCreate()
        }
      }
    },
    onCreate () {
      loading.push()
      this.dataAccount.password = this.dataAccount.password.toString()
      this.updatePermissionsForExternalUser()
      this.updateAccountDetails()

      if (this.dataAccount.externalUser) {
        this.createPersonAndAccount()
      } else {
        this.createAccount()
      }
    },
    onUpdate () {
      loading.push()
      this.dataAccount.id = parseInt(this.dataAccount.id)
      this.updateAccountPersonDetails()
      this.updatePermissionsForExternalUser()
      this.updateAccountDetails()

      if (this.dataAccount.externalUser) {
        this.updatePersonAndAccount()
      } else {
        this.updateAccount()
      }
    },
    updatePermissionsForExternalUser () {
      if (this.formAccount.externalUser.value) {
        this.dataAccount.permissoes = this.dataAccount.permissoes || []
        if (!this.dataAccount.permissoes.includes('USUARIO_EXTERNO')) {
          this.dataAccount.permissoes.push('USUARIO_EXTERNO')
        }
      }
    },
    updateAccountDetails () {
      this.dataAccount.funcionariosPermissaoId = this.usersAlreadyWithPermission ? this.usersAlreadyWithPermission.map((x) => x.funcionario.id) : []
      this.dataAccount.groupId = this.formAccount.grupos.value ? this.formAccount.grupos.value.map((x) => x.value) : []
    },
    createPersonAndAccount () {
      PersonRepository.Create(this.dataPerson)
        .then((response) => {
          if (response.data) {
            this.dataAccount.pessoaId = response.data.id
            this.createAccount()
          }
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    createAccount () {
      AccountRepository.Create(this.dataAccount)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    updateAccountPersonDetails () {
      if (!this.formAccount.funcionarioId.value) {
        this.dataAccount.pessoaId = this.formAccount.pessoaId.value
        this.dataAccount.funcionarioId = null
      } else {
        this.dataAccount.pessoaId = null
      }
    },
    updatePersonAndAccount () {
      let obj = {
        'id': this.dataPerson.id,
        'emailCorporativo': this.dataPerson.emailCorporativo
      }
      PersonRepository.Patch(obj)
        .then((response) => {
          if (response.data) {
            this.updateAccount()
          }
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    updateAccount () {
      AccountRepository.Update(this.dataAccount)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    onChangePassword () {
      loading.push()
      var dataPassword = {
        'currentPassword': this.dataAccount.currentPassword,
        'newPassword': this.dataAccount.password
      }
      AccountRepository.UpdatePassword(dataPassword)
        .then((response) => {
          loading.close()
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    loadEmployees () {
      EmployeeRepository.GetAll()
        .then((response) => {
          this.formAccount.funcionarioId.options = this.onResultDropdown(response, null, f => f.pessoa.nome)
          this.formAccount.funcionarioSubstitutoId.options = this.onResultDropdown(response, null, f => f.pessoa.nome)
        })
        .catch((err) => this.onException(err))
    },
    loadGroups () {
      GroupRepository.GetAllActive()
        .then((response) => {
          this.formAccount.grupos.options = []
          response.data.content.map(x => {
            this.formAccount.grupos.options.push({ 'text': x.nameGroup, 'value': x.id })
          })
        })
        .catch((err) => this.onException(err))
    },
    updatePermissionList (leftTable, rightTable) {
      this.usersList = leftTable
      this.usersAlreadyWithPermission = rightTable
    },
    onChangeExternalUser () {
      let isExternalUser = this.formAccount.externalUser.value

      // account form model
      this.formAccount.mfaActive.required = !isExternalUser
      this.formAccount.funcionarioId.required = !isExternalUser
      this.formAccount.administrador.required = !isExternalUser

      // person form model
      if (!this.editMode) {
        this.formPerson.document.required = isExternalUser
        this.formPerson.emailCorporativo.required = isExternalUser
        this.formPerson.nome.required = isExternalUser
        this.formPerson.tipoPessoa.required = isExternalUser
      }
    },
    validateDocument (document) {
      if (document) {
        let documentValue = document.value.toString().replace(/[^\d]+/g, '')
        let documentValid

        if (documentValue.length === 11) {
          documentValid = this.validateCpf(documentValue)
        } else {
          documentValid = this.validateCnpj(documentValue)
        }

        if (!documentValid) {
          toast.warning('Documento inválido')
          document.value = ''
        }
      }
    },
    validateCpf (document) {
      if (typeof document !== 'string') return false
      if (
        !document ||
        document === '00000000000' ||
        document === '11111111111' ||
        document === '22222222222' ||
        document === '33333333333' ||
        document === '44444444444' ||
        document === '55555555555' ||
        document === '66666666666' ||
        document === '77777777777' ||
        document === '88888888888' ||
        document === '99999999999'
      ) {
        return false
      }
      let soma = 0
      let resto
      for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(document.substring(i - 1, i)) * (11 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(document.substring(9, 10))) {
        return false
      }

      soma = 0
      for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(document.substring(i - 1, i)) * (12 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(document.substring(10, 11))) {
        if (resto === 0) return true
        return false
      }
      return true
    },
    validateCnpj (document) {
      if (typeof document !== 'string') return false
      if (
        !document ||
        document.length !== 14 ||
        document === '00000000000000' ||
        document === '11111111111111' ||
        document === '22222222222222' ||
        document === '33333333333333' ||
        document === '44444444444444' ||
        document === '55555555555555' ||
        document === '66666666666666' ||
        document === '77777777777777' ||
        document === '88888888888888' ||
        document === '99999999999999'
      ) {
        return false
      }

      // Valida DVs
      let tamanho = document.length - 2
      let numeros = document.substring(0, tamanho)
      let digitos = document.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado !== parseInt(digitos.charAt(0))) {
        return false
      }

      tamanho = tamanho + 1
      numeros = document.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado !== parseInt(digitos.charAt(1))) {
        return false
      }
      return true
    },
    verifyHasFuncionarioId (obj) {
      if (obj.funcionario) {
        this.hasFuncionarioId = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/account/components/add/accountadd.vue